import getIdentifier from '../../../../../getIdentifier';
import getTimeStamp from '../../../../../getTimeStamp';
import firebase from 'firebase/compat/app';
import STORE from '../../../../../store';

const addArchiveUnusedMetricTimelineEvent = ({
  metric,
  currentUserId,
  currentUserName,
  batch,
  accountId,
}: {
  metric: Metrics.NormalMetric | Metrics.CompoundMetric;
  currentUserId: string;
  currentUserName: string;
  batch: firebase.firestore.WriteBatch;
  accountId: string;
}) => {
  const id = getIdentifier();

  const timelineEventRef = STORE.getTimelineEventsRef({ accountId }).doc(id);

  batch.set(timelineEventRef, {
    id,
    timelineableId: metric.id,
    timelineableType: 'Metric' as 'Metric',
    createdOn: getTimeStamp(),
    createdBy: currentUserId,
    userId: currentUserId,
    headlineText: {
      userDisplayName: currentUserName,
      actionText: 'Archived metric',
      contextText: `"${metric.name}"`,
    },
  });
};

export default addArchiveUnusedMetricTimelineEvent;
